import Vue from 'vue';
// <!-- 单个权限 -->
// <button v-permission="'user:add'">添加用户</button>

// <!-- 多个权限（或） -->
// <button v-permission="['user:add', 'user:edit']">添加或编辑</button>

// <!-- 多个权限（且） -->
// <button v-permission="{ and: ['user:add', 'user:edit'] }">必须同时有添加和编辑权限</button>

// <!-- 多个权限（或） -->
// <button v-permission="{ or: ['user:delete', 'user:view'] }">拥有任一即可</button>

Vue.directive('permission', {
  inserted: function (el, binding, vnode) {
    const {
      value
    } = binding;
    if (!value) return;
    const {
      context: {
        $store: {
          getters: {
            roleAuthList
          }
        }
      }
    } = vnode;

    // 权限校验函数
    const hasPermission = key => !!roleAuthList[key];
    let isAuthorized = false;

    // ✅ 情况一：单个权限
    if (typeof value === 'string') {
      isAuthorized = hasPermission(value);
    } else if (Array.isArray(value)) {
      // ✅ 情况二：多个权限 或 关系
      isAuthorized = value.some(key => hasPermission(key));
    } else if (typeof value === 'object' && value !== null) {
      // ✅ 情况三：多个权限 且 关系
      if (value.and && Array.isArray(value.and)) {
        isAuthorized = value.and.every(key => hasPermission(key));
      } else if (value.or && Array.isArray(value.or)) {
        isAuthorized = value.or.some(key => hasPermission(key));
      }
    }

    // 如果未授权，移除元素
    if (!isAuthorized) {
      try {
        el.remove(); // Vue 2.2+
      } catch (e) {
        el.parentNode && el.parentNode.removeChild(el); // fallback
      }
    }
  }
});